// @flow
import axios from 'axios'
import {
  FETCH_CLIENTS_SUCCESS,
  FETCH_RECIPIENTS_SUCCESS,
  FETCH_USER_SUCCESS,
  FETCH_USERS_SUCCESS
} from '../constants'

export function fetchUser(userId: number) {
  return (dispatch: Function) =>
    axios.get(`/users/${userId}`).then((response) => {
      dispatch({ type: FETCH_USER_SUCCESS, user: response.data })
    })
}

export function fetchUsers() {
  return (dispatch: Function) =>
    axios.get('/users').then((response) => {
      dispatch({ type: FETCH_USERS_SUCCESS, users: response.data })
    })
}

export function updateOffer(
  userId: number,
  offerId: number,
  data: { offer: Object }
) {
  return () => axios.patch(`/users/${userId}/offers/${offerId}`, data)
}

export function fetchClients() {
  return (dispatch: Function) =>
    axios.get('/clients').then((response) => {
      dispatch({ type: FETCH_CLIENTS_SUCCESS, clients: response.data })
    })
}

export function fetchRecipients() {
  return (dispatch: Function) =>
    axios.get('/newsletter_recipients').then((response) => {
      dispatch({ type: FETCH_RECIPIENTS_SUCCESS, recipients: response.data })
    })
}



// WEBPACK FOOTER //
// ./src/actions/admin.js